import { motion } from "framer-motion";
import { Ticket, CalendarDays, MapPin, Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { VARNA_2027, TICKET_2027 } from "@/lib/platform";
import { goToTicketCheckout } from "./NationalNav";

export const TICKET_FEATURES = [
  "Цял ден с топ лектори и реални стратегии",
  "Достъп до общността на инвеститорите",
  "Кафе паузи и нетуъркинг включени",
];

export default function VarnaFunnel() {
  const navigate = useNavigate();

  return (
    <section id="varna-2027" data-testid="varna-funnel" className="relative bg-[#07152B] text-[#F5EBD9] py-24 lg:py-36 overflow-hidden">
      <div className="absolute inset-0 sunset-glow opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        {/* Left — pitch */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
        >
          <div className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5892E] mb-4 flex items-center gap-4">
            <span className="h-px w-10 bg-[#F5892E]" />
            Следващо събитие
          </div>
          <h2 className="font-display uppercase text-4xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
            Варна 2027.<br />
            <span className="text-[#F5892E]">Играта продължава.</span>
          </h2>
          <div className="mt-8 space-y-3">
            <div className="flex items-center gap-3 text-[#C8D4E6] text-lg">
              <CalendarDays className="w-5 h-5 text-[#F5892E] shrink-0" strokeWidth={2.2} />
              {VARNA_2027.date}
            </div>
            <div className="flex items-center gap-3 text-[#C8D4E6] text-lg">
              <MapPin className="w-5 h-5 text-[#F5892E] shrink-0" strokeWidth={2.2} />
              Варна, България · {VARNA_2027.venue}
            </div>
          </div>
          <button
            onClick={() => { navigate("/varna-2027"); window.scrollTo({ top: 0 }); }}
            data-testid="funnel-details-link"
            className="mt-8 font-mono text-[11px] uppercase tracking-[0.24em] text-[#F5EBD9]/70 underline underline-offset-4 hover:text-[#F5892E] transition-colors"
          >
            Виж страницата на събитието
          </button>
        </motion.div>

        {/* Right — ticket card */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.9, delay: 0.15 }}
          data-testid="ticket-card-2027"
          className="relative bg-[#0F284B] border-2 border-[#F5892E] rounded-2xl p-8 sm:p-10 shadow-[0_0_80px_-20px_rgba(245,137,46,0.45)]"
        >
          <div className="inline-flex items-center gap-2 bg-[#F5892E] text-[#0B1F3D] font-mono text-[10px] uppercase tracking-[0.26em] font-bold px-3.5 py-1.5 rounded-full mb-7">
            <Ticket className="w-3.5 h-3.5" strokeWidth={2.6} />
            Early Bird
          </div>

          <div className="flex items-baseline gap-3 mb-2">
            <span className="font-display text-8xl sm:text-9xl leading-none tracking-tight">{TICKET_2027.price}</span>
            <span className="font-display text-3xl text-[#F5892E]">€</span>
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#8A9EB8] mb-8">
            билет за Варна 2027
          </div>

          <ul className="space-y-3.5 mb-9">
            {TICKET_FEATURES.map((f) => (
              <li key={f} className="flex items-start gap-3 text-[#C8D4E6] text-sm">
                <Check className="w-4.5 h-4.5 w-5 h-5 text-[#F5892E] shrink-0 mt-0.5" strokeWidth={2.4} />
                {f}
              </li>
            ))}
          </ul>

          <p className="text-sm text-[#8A9EB8] mb-7 leading-relaxed">
            Вземи своя билет за следващото издание на „Играта на имотите" във Варна.
          </p>

          <button
            onClick={goToTicketCheckout}
            data-testid="funnel-cta-ticket"
            className="w-full py-5 rounded-full bg-[#F5892E] text-[#0B1F3D] font-bold text-base uppercase tracking-widest hover:bg-[#F5EBD9] transition-colors inline-flex items-center justify-center gap-3"
          >
            <Ticket className="w-5 h-5" strokeWidth={2.4} />
            Вземи билет — 34 €
          </button>
          <div className="mt-4 text-center font-mono text-[9px] uppercase tracking-[0.22em] text-[#8A9EB8]">
            Сигурно плащане чрез Stripe
          </div>
        </motion.div>
      </div>
    </section>
  );
}
